import { useTranslation } from 'react-i18next';

import { Pencil } from 'tabler-icons-react';

import { GreyReplaceIcon } from 'assets';
import { ActionsDropdown } from 'components/shared';

type RentedPalletsSummarySectionActionsDropdownProps = {
   onClickMovePallets: () => void;
   onClickEditPalletsBalance: () => void;
};

const RentedPalletsSummarySectionActionsDropdown = ({
   onClickMovePallets,
   onClickEditPalletsBalance,
}: RentedPalletsSummarySectionActionsDropdownProps) => {
   const { t } = useTranslation();

   const options = [
      {
         text: t('rentedPalletsSummary.actionsDropdown.move'),
         icon: <GreyReplaceIcon />,
         onClick: onClickMovePallets,
      },
      {
         text: t('storage.editPalletStock'),
         icon: <Pencil color={'#A6A6B2'} />,
         onClick: onClickEditPalletsBalance,
      },
   ];

   return <ActionsDropdown options={options} />;
};

export default RentedPalletsSummarySectionActionsDropdown;
